import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

export const deleteNode = async (
  nodeId: string,
  options: ServiceRequestConfig = {},
) => {
  await managedEntities.remove(`/nodes/${nodeId}`, {
    showErrorToast: true,
    ...options,
  });
};
